import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.scss';
import whiteLogo from '../../assets/WHITE.png';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer__container">
        <div className="footer__top">
          <div className="footer__brand">
            <img src={whiteLogo} alt="Shtrom" className="footer__logo" />
          </div>
          
          <nav className="footer__nav">
            <div className="footer__nav-group">
              <span className="footer__nav-label">Shop</span>
              <Link to="/collections/all" className="footer__nav-link">All Products</Link>
              {/* <Link to="/lookbook" className="footer__nav-link">Lookbook</Link> */}
              <Link to="/archive" className="footer__nav-link">Archive</Link>
            </div>
            
            <div className="footer__nav-group">
              <span className="footer__nav-label">Info</span>
              <Link to="/about" className="footer__nav-link">About</Link>
              {/* <Link to="/contact" className="footer__nav-link">Contact</Link> */}
              {/* <Link to="/stockists" className="footer__nav-link">Stockists</Link> */}
            </div>
            
            <div className="footer__nav-group">
              <span className="footer__nav-label">Legal</span>
              <Link to="/terms" className="footer__nav-link">Terms & Conditions</Link>
              <Link to="/privacy" className="footer__nav-link">Privacy Policy</Link>
              <Link to="/refund" className="footer__nav-link">Refund Policy</Link>
              <Link to="/accessibility" className="footer__nav-link">Accessibility</Link>
            </div>
          </nav>
        </div>

        <div className="footer__bottom">
          <p className="footer__copyright">© {currentYear} $HTROM.LLC</p>
          <a href="mailto:support@shtromstudio.com" className="footer__email">
            support@shtromstudio.com
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
